<template>
	<div class="content">
		<!--<div class="header-box"> 2023年职业院校数字化转型典型案例评价表 </div>-->
		<!--<div class="bg-box">-->
		<!--<div class="line"></div>-->
		<div class="content-box  flex flex-col">
			<div class="contentsj">
				<div class="headerbt">
					{{ items.zpname }}
					<div class="back" @click="goback">
						<img style="width: 30px; height: 30px; cursor: pointer" src="@/assets/images/img59.png" alt=""
							title="返回" />
					</div>
				</div>

				<div v-for="(item, index) in treeFile">
					<div v-if="index == '0'">
						<h4 style="margin-bottom:10px;"><img class="img-box-2" src="@/assets/images/img24.png"
								alt="" />{{ item.title }}</h4>
						<div class="flieList">
							<span class="listitem" @click="gohrefs(items.filePath, item.title, item.previewPath)"
								v-for="(items, index1) in item.children">
								{{ getFileName(items.filePath) }}
							</span>
						</div>
						<div class="pdf-wrap"
							v-if="(previewType.toLowerCase() === 'pdf' || previewType === 'doc' || previewType === 'docx') && defaultGraph === false">
							<iframe ref="iframe" width="120%" :src="previewUrl" name="123" scrolling-y="auto"
								frameborder="0" style="width: 100%; height: 100%; background: #fff"></iframe>
						</div>
						<div class="img-preview-box" v-if="(
							(previewType === 'jpg' ||
								previewType === 'png' ||
								previewType === 'jpeg' ||
								previewType === 'bmp') && defaultGraph === false)">
							<img class="img-preview" :src="previewUrl" alt="" />
						</div>

						<div class="videowrap"
							v-if="(previewType === 'mp4' || previewType === 'MP4') && defaultGraph === false">
							<video style="height: 100%; width: 100%" controls controlsList="nodownload"
								autoplay="autoplay" :src="previewUrl"></video>
						</div>
						<div class="msg-box" v-if="defaultGraph">
							<div>
								<img style="width: 465px; height: 291px" src="~@/assets/images/img53.png" alt="" />
							</div>
							<div class="tip">暂无内容</div>
						</div>
					</div>
					<div v-if="index != '0'">
						<h4> <img class="img-box-2" src="@/assets/images/img24.png" alt="" />{{ item.title }}</h4>
						<div class="flieList">
							<span class="listitem" @click="gohref(items.filePath, item.title, items.previewPath)"
								v-for="(items, index1) in item.children">
								{{ getFileName(items.filePath) }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<h5 class="headerScore" v-if="izScoring">评审表</h5>
			<div class="review-content">
				<div v-if="izScoring">
					<a-table class="table" :columns="columns" :data-source="reviewData.dataList" bordered
						:pagination="false" :rowKey="(record) => record.id">
						<span slot="oneTarget" slot-scope="text">{{ text }}</span>
						<template slot="content" slot-scope="text, record">
							<div>
								<span
									style="white-space: pre-line;text-align: left;font-size: 18px;line-height:28px;display: block;">{{ transform(text) }}</span>
							</div>
						</template>
						<template slot="itemScore" slot-scope="text, record">
							<editable-cell :evaluationTablePreview="evaluationTablePreview" :max="record.score"
								:text="text" @change="onCellChange(record.id, 'itemScore', $event)" />
						</template>
					</a-table>
					<div class="target-score">
						<span>
							指标总分值：
							<span class="number">{{ targetTotalScore }}</span>
							<span class="score">分</span>
						</span>
						<span style="margin-left: 30px">
							总得分：
							<span class="number">{{ totalPoints }}</span>
							<span class="score">分</span>
						</span>
					</div>
				</div>
				<div class="expertReviews" v-if="izReview">
					<div class="expertReviews-title">专家评语</div>
					<a-textarea class="remark-input" v-model="reviewData.remark" placeholder="请输入评语~" :maxLength="500"
						:auto-size="{ minRows: 4, maxRows: 6 }" :disabled="evaluationTablePreview" />
				</div>
				<div class="submit" @click="submit" v-if="!evaluationTablePreview && (izReview || izScoring)">提交</div>
			</div>
		</div>
		<!--<div class="line"></div>-->
		<!--</div>-->
		<!--<div>
			<foot :FootType="2"></foot>
		</div>-->
		<div class="preview-pop-box" v-if="isshow">
			<div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
				<sjshow :previewType="fileType" :title="title" :previewUrl="fileUrl" @goNewPage="goNewPage"
					@closePreview="closePreview"></sjshow>

			</div>
		</div>

	</div>
</template>

<script>
import sjshow from "./sjshow";
import foot from "@/components/footer";
const EditableCell = {
	template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input-number :max="max" :min="0" :autoFocus="autoFocus":value="value" @change="handleChange" @mouseout="check" @pressEnter="check" @blur="check"/>
        </div>
        <div v-else class="editable-cell-text-wrapper" >
           <div v-if="evaluationTablePreview" style="width:100%;height:100%;display: flex;align-items: center;">	
            <span style="width:100%;"   >{{ value || ' ' }}</span>
           </div>
           <div v-else style="width:100%;height:32px;display: flex;align-items: center;" @mouseover="edit">	
            <span style="width:100%;"   >{{ value || ' ' }}</span>
           </div>
        </div>
      </div>
    `,
	props: {
		text: {
			type: String,
			default: '',
		},
		max: {
			type: Number,
			default: 0
		},
		evaluationTablePreview: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			value: this.text,
			editable: false,
			autoFocus: true,
			item: {},

		};
	},
	methods: {
		handleChange(value) {
			if (value > this.max) {
				this.$message.warn('输入得分超出对应分值,按对应分值最高分评分');
			}
			this.value = value;
		},
		check() {
			this.editable = false;
			this.$emit("change", this.value);
		},
		edit() {
			this.editable = true;
		},
	},
};
import { baseURL } from "@/utils/request.js";
import { getAction, postAction, expertDateView } from "@/api/index";
export default {
	components: {
		EditableCell,
		foot,
		sjshow
	},
	data() {
		return {
			zpname: '',
			id: '',
			expertUserId: '',
			isshow: false,
			evaluationTablePreview: false,
			targetTotalScore: 0,
			totalPoints: 0,
			fileType: '',
			fileUrl: '',
			columns: [{
				title: "评价维度",
				dataIndex: "oneTarget",
				key: "oneTarget",
				align: "center",
				width: 120,
				scopedSlots: {
					customRender: "oneTarget"
				},
				customRender: (text, record, index) => {
					const obj = {
						children: record.oneTarget,
						attrs: {},
					}
					obj.attrs.rowSpan = this.columnsInit(record.oneTarget, this.reviewData.dataList, 'oneTarget', index)
					return obj
				},
			},
			{
				title: "评价指标",
				dataIndex: "twoTarget",
				key: "twoTarget",
				align: "center",
			},
			{
				title: "评价要点",
				dataIndex: "content",
				key: "content",
				//			          ellipsis: true,
				scopedSlots: {
					customRender: "content"
				},
				align: "center",
			},
			{
				title: "分值",
				dataIndex: "score",
				key: "score",
				width: 80,
				align: "center",
			},
			{
				title: "得分",
				dataIndex: "itemScore",
				key: "itemScore",
				align: "center",
				width: 130,
				scopedSlots: {
					customRender: "itemScore"
				},
			},
			],
			reviewData: {
				// 专家评语
				remark: "",
				// 指标数据
				dataList: [],
			},
			// 评审
			reviewShow: false,
			emptyPrompt: false,
			targetTotalScore: 0,
			// 总得分
			totalPoints: 0,
			reviewEndTimestamp: '',
			treeFile: [],
			previewType: '',
			previewUrl: '',
			defaultGraph: false,
			title: '',
			fullscreen: false,
			izScoring: false,
			izReview: false,
		}
	},
	created() {
		this.items = JSON.parse(localStorage.getItem('items'));
	},
	mounted() {
		this.items = JSON.parse(localStorage.getItem('items'));
		// console.log(this.items,"2222");
		this.id = this.items.id;
		this.expertUserId = this.$route.query.userid,
			this.getStatus();
		this.getData();
		//				this.zpname = this.$route.query.zpname,
		this.getexpertDateView();
	},
	destroyed() {
		localStorage.removeItem('items');
	},
	methods: {
		getStatus() {
			getAction('/lx/lxApply/getReviewAndScore', {}).then((res) => {
				if (res.code === 200) {
					// console.log(res,"333");
					this.izScoring = res.result.izScoring == 1 ? true : false;
					this.izReview = res.result.izReview == 1 ? true : false;
					if (this.izScoring) {
						this.getReviewTable();
					}
				} else {
					this.$message.error(res.message);
				}
			});
		},
		goNewPage(flag) {
			//    console.log(flag);
			this.fullscreen = flag;
		},
		getFileName(name) {
			let newName = name.slice(name.lastIndexOf("/") + 1);
			let firstname = newName.slice(0, newName.lastIndexOf("_"));
			let lastname = newName.slice(newName.lastIndexOf("."));
			return firstname + lastname;
		},
		getData() {
			let treeFile = [];
			if (this.items && this.items.applyType == '4') {
				treeFile = [
					{
						title: "教学视频",
						key: 1,
						children: [],
					},
					// {
					// 	title: "数字化典型案例",
					// 	key: 9,
					// 	children: [],
					// },
					{
						title: "教学设计",
						key: 2,
						children: [],
					},
					{
						title: "微课逐字稿",
						key: 3,
						children: [],
					},
					{
						title: "联络人信息表",
						key: 4,
						children: [],
					},
					{
						title: "参赛作品汇总表",
						key: 5,
						children: [],
					},
					{
					title: "参赛作品推荐表",
					key: 6,
					children: [],
				},
				{
					title: "微课课件",
					key: 7,
					children: [],
				},
				{
					title: "参赛作品信息表",
					key: 8,
					children: [],
				},
				// {
				// 	title: "佐证材料",
				// 	key: 3,
				// 	children: [],
				// },
			];
			} else {
				treeFile = [
					// {
					// 	title: "数字化典型案例",
					// 	key: 1,
					// 	children: [],
					// },
					{
						title: "数字化典型案例",
						key: 9,
						children: [],
					},
					{
						title: "典型案例报送申请表",
						key: 2,
						children: [],
					},
					// {
					// 	title: "佐证材料",
					// 	key: 3,
					// 	children: [],
					// },
				];
			}


			for (let i = 0; i < treeFile.length; i++) {
				treeFile[i].hadThree = false;
				for (let j = 0; j < this.items.applyFiles.length; j++) {
					if (treeFile[i].key == this.items.applyFiles[j].fileType) {
						// this.items.applyFiles[j].proviewPath=null;
						treeFile[i].children.push(this.items.applyFiles[j]);
					}
				}
			}
			this.treeFile = treeFile;
			// console.log(this.treeFile);
			if (this.treeFile.length > 0 && this.treeFile[0].children.length > 0) {
				let filePath = this.treeFile[0].children[0].filePath;
				if (filePath != '') {
					let fileName = filePath.lastIndexOf(".");
					this.previewType = filePath.substring(
						fileName + 1,
						filePath.length
					);
					let sj = filePath.substring(0, filePath.lastIndexOf("."));
					console.log(this.previewType, "33333");
					if (this.previewType == 'mp4') {
						sj = sj + ".mp4";
					} else {
						sj = sj + ".pdf";
					}

					if (this.previewType === "doc" || this.previewType === "docx" || this.previewType === "ppt" || this.previewType === "pptx" || this.previewType === "xls" || this.previewType === "xlsx") {

						this.previewUrl = sj + "?time=" + Math.random() + "#zoom=120";
					} else {
						this.previewUrl = baseURL + sj + "?time=" + Math.random() + "#zoom=120";
					}
					this.defaultGraph = false;
				} else {
					this.defaultGraph = true;
				}

			} else {
				this.defaultGraph = true;
			}
		},
		transform(text) {
			return String(text).replaceAll("\\n", "\n");
		},
		onCellChange(key, dataIndex, value) {
			const dataSource = [...this.reviewData.dataList];
			const target = dataSource.find((item) => item.id === key);
			if (target) {
				target[dataIndex] = value;
				this.reviewData.dataList = dataSource;
			}
			this.totalPoints = 0;
			this.reviewData.dataList.forEach((item) => {
				this.totalPoints += Number(item.itemScore);
			});
			//		      window.sessionStorage.setItem(
			//		        `${this.preViewData.id}reviewData`,
			//		        JSON.stringify(this.reviewData)
			//		      );
		},
		// 评审提交
		submit() {
			var date1 = new Date();
			var timestamp = Date.parse(date1);
			if (timestamp > this.reviewEndTimestamp) {
				this.$message.error('评审时间已经结束');
				return false;
			}
			let map = {};
			this.reviewData.dataList.forEach((item) => {
				map[item.id] = Number(item.itemScore);
			});
			let params = {
				itemScores: map,
				applyId: this.id,
				remark: this.reviewData.remark,
			};
			postAction("/lx/lxExpertItem/settingScore", params).then((res) => {
				if (res.code == 200) {
					this.$message.success("提交成功");
					let that = this
					setTimeout(function () {
						localStorage.removeItem('items');
						if (that.items && that.items.applyType == '4') {
							that.$router.push({ path: '/personalCenter/alApply' });
						} else {
							that.$router.push({ path: '/personalCenter/xalApply' });
						}

					}, 2000)


				} else if (res.code == 500) {
					this.$message.error(res.message);
				}
			});
		},
		goback() {
			this.$router.push({ name: 'alApply' }); localStorage.removeItem('items');
			// if(this.items && this.items.applyType=='4'){

			// }else{
			// 	  this.$router.push({ name: 'xal' }); localStorage.removeItem('items');
			// }

		},
		getReviewTable() {
			let params = {
				applyType: 4,
				applyId: this.id,
				expertUserId: this.expertUserId,
			};
			if (this.items && this.items.applyType == '4') {
				params.applyType = 4;
			} else {
				params.applyType = 1;
			}
			getAction("/lx/lxExpertItem/tablelist", params).then((res) => {
				if (res.code == 200) {
					this.reviewData = res.result;
					this.targetTotalScore = 0
					this.totalPoints = 0
					this.reviewData.dataList.forEach((item) => {
						this.targetTotalScore += item.score;
						this.totalPoints += Number(item.itemScore);
					});
					if (!this.reviewData.hasOne) {
						this.columns = this.columns.filter(
							(item) => item.title != "评价维度"
						);
					}
				}
			});
		},
		gohrefs(url, title, urls) {
			// console.log(urls,"33333333");
			if (urls) {
				let filePath = url;
				let fileName = filePath.lastIndexOf(".");
				this.previewType = filePath.substring(
					fileName + 1,
					filePath.length
				);

				if (this.fileType === "doc" || this.fileType === "docx" || this.fileType === "ppt" || this.fileType === "pptx" || this.fileType === "xls" || this.fileType === "xlsx") {
					this.previewUrl = urls + "?time=" + Math.random();
				} else {
					this.previewUrl = urls + "?time=" + Math.random();
				}
				console.log(this.previewUrl, "55555");
			} else {
				let filePath = url;
				let fileName = filePath.lastIndexOf(".");
				this.previewType = filePath.substring(
					fileName + 1,
					filePath.length
				);
				let sj = filePath.substring(0, filePath.lastIndexOf("."));
				sj = sj + ".pdf";
				if (this.fileType === "doc" || this.fileType === "docx" || this.fileType === "ppt" || this.fileType === "pptx" || this.fileType === "xls" || this.fileType === "xlsx") {
					this.previewUrl = sj + "?time=" + Math.random() + "#zoom=120";
				} else {
					this.previewUrl = baseURL + sj + "?time=" + Math.random() + "#zoom=120";
				}
			}
		},
		gohref(url, title, urls) {
			// console.log(urls,"4444");
			if (urls) {
				let filePath = url;
				let fileName = filePath.lastIndexOf(".");
				this.fileType = filePath.substring(
					fileName + 1,
					filePath.length
				);
				if (this.fileType === "doc" || this.fileType === "docx" || this.fileType === "ppt" || this.fileType === "pptx" || this.fileType === "xls" || this.fileType === "xlsx") {
					this.fileUrl = urls + "?time=" + Math.random();
				} else {
					this.fileUrl = urls + "?time=" + Math.random();
				}
			} else {
				let filePath = url;
				let fileName = filePath.lastIndexOf(".");
				this.fileType = filePath.substring(
					fileName + 1,
					filePath.length
				);
				let sj = filePath.substring(0, filePath.lastIndexOf("."));
				sj = sj + ".pdf";
				if (this.fileType === "doc" || this.fileType === "docx" || this.fileType === "ppt" || this.fileType === "pptx" || this.fileType === "xls" || this.fileType === "xlsx") {
					this.fileUrl = sj + "?time=" + Math.random();
				} else {
					this.fileUrl = baseURL + sj + "?time=" + Math.random();
				}
			}

			this.title = title;
			this.isshow = true;
		},
		// 获取评审时间
		getexpertDateView() {
			expertDateView().then((res) => {
				if (res.code == 200) {
					this.reviewEndTimestamp = res.result.endTime;
				}
			});
		},
		closePreview() {
			this.isshow = false;
			this.title = '';
			this.fileType = '';
			this.fileUrl = '';
		},
		// 合并单元格
		columnsInit(text, data, key, index) {
			if (index !== 0 && text == data[index - 1][key]) {
				return 0
			}
			let rowSpan = 1 //判断下一行是否相等
			for (let i = index + 1; i < data.length; i++) {
				if (text !== data[i][key]) {
					break
				}
				rowSpan++
			}
			return rowSpan
		},

	}
}
</script>
<style scoped lang="scss">
@import '@/assets/style/mixin.scss';

.content {
	width: 100%;
	min-height: 100vh;
	position: relative;
	/*.header-box {
			height: 172px;
			text-align: center;
			font-size: 47px;
			color: #fff;
			line-height: 172px;
			text-shadow: 2px 3px rgba(0, 0, 0, 0.5);
			background: url(/img/header-bg-al.4be82833.jpg);
			background-size: 100% 100%;
		}*/
}

.msg-box {
	width: 100%;
	height: 400px;

	img {
		display: block;
		margin: 20px auto;
	}

	.tip {
		color: #000;
		font-size: 16px;
		line-height: 40px;
		text-align: center;
	}
}

.back {
	width: 30px;
	height: 30px;
	position: absolute;
	top: 5px;
	right: 10px;
}

.videowrap {
	width: 85%;
	height: 600px;
	margin: 20px auto;
}

.contentsj {
	h4 {
		/*font-weight:bold;*/
		line-height: 40px;
		margin: 0px;
		font-size: 18px;
	}

	.img-preview {
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
		position: absolute;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	.img-preview-box {
		position: relative;
		max-height: 718px;
		overflow: hidden;
		width: 100%;
		height: 500px;
		/*background: #000;*/
	}
}

.headerbt {
	height: 40px;
	text-align: center;
	font-size: 24px;
	line-height: 40px;
	position: relative;
}

.preview-pop-box {
	width: 100vw;
	height: 100vh;
	position: fixed;
	z-index: 999;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.5);

	.preview-box {
		margin: 50px auto;
		width: 1177px;
		height: 90%;
	}

	.preview-box-fullscreen {
		width: 100vw;
		height: 100vh;
	}
}

* {
	font-size: 18px;
}

.img-box-2 {
	width: 19px;
	height: 19px;
	margin-right: 10px;
}

.bg-box {
	@include themeify {
		background: themed(content-bg) no-repeat bottom center, #f8f9ff;
		background-size: 100% auto;
	}
}

.line {
	height: 20px;
}

.pdf-wrap {
	width: 1290px;
	height: 1170px;
	margin: 0px auto;
}

/*.pdf-wrap{
		width:90%;
		height:800px;
		margin:0px auto;
	}*/
.flieList {
	width: 100%;
	min-height: 30px;
	display: flex;
	justify-content: flex-start;
	align-items: center;

	.listitem {
		font-size: 14px;
		margin-right: 20px;
		color: #9A0B00;
		;
		padding: 0px 10px;
		cursor: pointer;
	}

	.listitem:hover {}
}

.content-box {
	/*width: 1350px;
		min-height: 100vh;
		position: relative;
		margin: 0px auto;*/
	padding: 19px 30px;
	box-sizing: border-box;
	background-color: #fff;
}

.headerScore {
	font-size: 24px;
	font-weight: bold;
	line-height: 40px;
	text-align: center;
}

.review-content {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	padding-bottom: 10px;

	/*margin-top:30px;*/
	.table {
		/deep/ .ant-table-thead>tr>th {
			font-size: 18px !important;
		}

		/deep/ .ant-table-tbody>tr>td {
			font-size: 18px;
			padding: 15px !important;
		}
	}
}

.target-score {
	margin-top: 10px;
	color: #6c6c6c;
	text-align: right;

	.number {
		font-size: 20px;
		color: #9A0B00;
	}

	.score {
		color: #9A0B00;
	}
}

.expertReviews-title {
	font-size: 18px;
	color: #000;
}

.expertReviews-title:before {
	display: inline-block;
	width: 6px;
	height: 22px;
	background: #9A0B00;
	border-radius: 5px;
	content: "";
	/**
			    这个指为正的话 小方块就往上， 为负的话，小方块就往下
			    */
	vertical-align: middle;
	margin-right: 6px;
}

.remark-input {
	margin-top: 20px;
	resize: none;
}

.submit {
	width: 263px;
	height: 41px;
	background: #9A0B00;
	border-radius: 8px;
	line-height: 41px;
	text-align: center;
	margin: 0 auto;
	color: #ffffff;
	margin-top: 30px;
	cursor: pointer;
}
</style>